import styled from "styled-components";
import { H3 } from "@genesys/ui-elements";

export const StyledH3 = styled(H3)`
  margin-top: 5px;
  font-size: 15px;
`;

export const Label = styled.label`
  color: rgb(0, 177, 247);
  cursor: pointer;
`;

export const FlexContainerCenter = styled.div`
  display: flex;
  align-items: center;
`;
